exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dp-suffix option[data-v-5d69891a]:first-child{color:#90949c}.dp-suffix option[data-v-5d69891a]:not(:first-child){color:#495057}", ""]);

// exports
